import { useLanguageData } from '@/common/hooks/useLanguageData';
import { ORDER_STATUS_PHASE } from '../constants/orderStatus.constants';
import useOrderStatusFailureRedirect from '../hooks/useOrderStatusFailureRedirect';
import {
	Actions,
	BrandMark,
	BrandRow,
	IconBadge,
	Message,
	PrimaryButton,
	SecondaryLink,
	StatusCard,
	StatusPill,
	Title,
	VisualBlock,
} from '../orderStatusPage.styles';
import { ErrorIcon } from './OrderStatusIcons';

const OrderStatusFailed = ({ params, timeoutTriggered }) => {
	const t = useLanguageData('chat');
	const { handleRetryCheckout } = useOrderStatusFailureRedirect(
		params,
		ORDER_STATUS_PHASE.FAILED,
		timeoutTriggered,
	);

	return (
		<StatusCard $phase={ORDER_STATUS_PHASE.FAILED} aria-live='polite'>
			<BrandRow>
				<BrandMark>SoftAI</BrandMark>
				<StatusPill $phase={ORDER_STATUS_PHASE.FAILED}>
					{t.orderStatusPillFailed}
				</StatusPill>
			</BrandRow>
			<VisualBlock>
				<IconBadge $phase={ORDER_STATUS_PHASE.FAILED} aria-hidden='true'>
					<ErrorIcon />
				</IconBadge>
				<Title>{t.orderStatusPaymentFailed}</Title>
				<Message>{t.orderStatusPaymentFailedDescription}</Message>
			</VisualBlock>
			{!params.fromQuiz && (
				<Actions>
					<PrimaryButton type='button' onClick={handleRetryCheckout}>
						{t.orderStatusBackToCheckout}
					</PrimaryButton>
					<SecondaryLink href='/'>{t.orderStatusGoToLogin}</SecondaryLink>
				</Actions>
			)}
		</StatusCard>
	);
};

export default OrderStatusFailed;
